import { CameraAlt } from '@mui/icons-material';
import { Alert, Box, Button, Divider, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useEffect, useState, useCallback } from 'react'
import FilterAfterFetch from './FilterAfterFetch';
import { isFirefox, isIE, isMobile } from 'react-device-detect';
import { FileUploader } from 'react-drag-drop-files';
import { useTranslation } from 'react-i18next';

CanvasRenderingContext2D.prototype.clear =
    CanvasRenderingContext2D.prototype.clear || function (preserveTransform) {
        if (preserveTransform) {
            this.save();
            this.setTransform(1, 0, 0, 1, 0, 0);
        }

        this.clearRect(0, 0, this.canvas.width, this.canvas.height);

        if (preserveTransform) {
            this.restore();
        }
    };

const fileTypes = ["JPG", "JPEG", "PNG", "GIF", "WEBP"];

const ImageComponent = ({ image, detections, selectImage, setLoading, setItems, setFilters,
    filter, price, category, setDetection, loading, selDet, api, setDets, setShow }) => {

    const { t, i18n } = useTranslation(['translation']);

    const [fileError, setFileError] = useState(false);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [originalDimensions, setOriginalDimensions] = useState({ width: 0, height: 0 });
    const [resizeFactor, setResizeFactor] = useState(1);
    //const [selectedDetection, setSelectedDetection] = useState(selDet ? selDet : null);
    const [selectedDetection, setSelectedDetection] = useState(selDet ? selDet : null);

    // console.log(selDet)
    // console.log('-------------------')
    // console.log(selectedDetection)

    let imageRef = HTMLInputElement;
    let canvasRef = HTMLInputElement;

    const handleChange = (file) => {
        setDets(null)
        setDetection(null)
        setDimensions({ width: 0, height: 0 })
        setOriginalDimensions({ width: 0, height: 0 })
        setSelectedDetection(null)
        selectImage(file)
        setShow(true)
    }

    const checkImage = (file) => {
        if (!file.name.match(/\.(jpg|jpeg|png|webp|JPG|JPEG|PNG|WEBP)$/)) {
            setFileError(true);
        } else {
            setLoading(true);
            setItems(null);
            selectImage(file);
        }
    }

    const drawCircle = (ctx, x, y, radius, fill, stroke, strokeWidth) => {
        // console.log('drawCircle')
        ctx.save();
        ctx.fillStyle = fill;
        ctx.strokeStyle = stroke;
        ctx.lineWidth = strokeWidth;
        const circle = new Path2D();
        circle.arc(x, y, radius, 0, 2 * Math.PI);
        ctx.fill(circle);
        ctx.stroke(circle);
        ctx.restore();
    }

    const drawRect = (ctx, x, y, w, h, fill, stroke, strokeWidth) => {
        // console.log('drawRect')
        ctx.save();
        ctx.fillStyle = fill;
        ctx.strokeStyle = stroke;
        ctx.lineWidth = strokeWidth;
        ctx.beginPath();
        if (isFirefox || isIE || isMobile)
            ctx.rect(x, y, w, h, 10);
        else
            ctx.roundRect(x, y, w, h, 10);
        ctx.rect(400, 0, -400, 800);
        ctx.stroke();
        ctx.fill();
        ctx.restore();
    }

    const onImgLoad = ({ target: img }) => {
        if (img.offsetWidth > 0 && (img.offsetWidth !== dimensions.width || img.offsetHeight !== dimensions.height))
            setDimensions({ width: img.offsetWidth, height: img.offsetHeight })
    }

    const canvasClick = (event) => {
        var clickX = event.pageX - canvasRef.getBoundingClientRect().left,
            clickY = event.pageY - canvasRef.getBoundingClientRect().top;
        // console.log('In canva click' + loading + '--------')
        // console.log(clickX, clickY)
        if (!loading) {
            detections.forEach(function (element) {
                var top = (element.ycenter - element.height / 2) / resizeFactor;
                var left = (element.xcenter - element.width / 2) / resizeFactor;
                var height = element.height / resizeFactor;
                var width = element.width / resizeFactor;
                var centerx = left + width / 2;
                var centery = top + height / 2;
                if (clickY > centery - 20 && clickY < centery + 20
                    && clickX > centerx - 20 && clickX < centerx + 20) {
                        setSelectedDetection(element);
                        setShow(true)
                    }
                //setDetection(element)
            });
        }
    }

    
    useEffect(() => {
        if(selectedDetection === null && detections) {
            console.log('ELEMENT')
            setSelectedDetection(detections[0])
        }
    }, [detections])
    

    // useEffect(() => {
    //     if (selectedDetection === null && detections) {
    //         console.log('ELEMENT')
    //         console.log(detections[0])
    //         console.log('ELEMENT')
    //         setSelectedDetection(detections[0])
    //     }
    // }, [selectedDetection, detections])


    useEffect(() => {
        // console.log("Detections: " , detections, "--------")
        // console.log("SelectedDetection: " , selectedDetection, "--------")

        const drawDetections = (selDetection) => {
            var ctx = canvasRef.getContext("2d");
            ctx.clear();

            if (dimensions && dimensions.width > 0 && dimensions.height > 0 && detections && selectedDetection) {
                detections.forEach(function (element) {
                    if (element.xcenter === selDetection.xcenter && element.ycenter === selDetection.ycenter && element.width === selDetection.width && element.height === selDetection.height)
                        drawRect(ctx, (element.xcenter - element.width / 2) / resizeFactor, (element.ycenter - element.height / 2) / resizeFactor, element.width / resizeFactor, element.height / resizeFactor, 'rgba(0, 0, 0, .33)', 'white', 2);
                });
                detections.forEach(function (element) {
                    // if (detections.length == 1) {
                    //     drawCircle(ctx, element.xcenter / resizeFactor, element.ycenter / resizeFactor, 8, 'rgba(255, 255, 255, .33)', '#FA4616', 6);
                    // }
                    if (element.xcenter !== selDetection.xcenter || element.ycenter !== selDetection.ycenter || element.width !== selDetection.width || element.height !== selDetection.height)
                        drawCircle(ctx, element.xcenter / resizeFactor, element.ycenter / resizeFactor, 8, 'rgba(255, 255, 255, .33)', '#FA4616', 6);
                });
            }
        }

        setDetection(selectedDetection);
        drawDetections(selectedDetection);

    }, [detections, selectedDetection, setDetection, canvasRef, dimensions, resizeFactor]);

    useEffect(() => {
        const drawCanvas = () => {
            // console.log('drawCanvas')
            // console.log(dimensions)
            if (dimensions && dimensions.width > 0 && dimensions.height > 0) {
                canvasRef.width = dimensions.width;
                canvasRef.height = dimensions.height;
            }
        }

        drawCanvas();

    }, [dimensions]);

    /*
    useEffect(() => {
        // console.log('setSelectedDetection')
        // console.log(detections)        
        if (detections && detections.length)
            setSelectedDetection(detections[0]);
        // drawCanvas();
        //drawDetections();
    }, [detections, resizeFactor]);
    */

    useEffect(() => {
        if (originalDimensions.width > 0 && dimensions.width > 0)
            setResizeFactor(originalDimensions.width / dimensions.width);
    }, [dimensions, originalDimensions]);

    useEffect(() => {
        const tempimg = new Image();
        tempimg.src = URL.createObjectURL(image);
        tempimg.onload = () => {
            setOriginalDimensions({
                width: tempimg.width,
                height: tempimg.height
            });
        };
        tempimg.onerror = (err) => {
            console.log("img error");
            console.error(err);
        };

        window.addEventListener('resize', () => {
            // console.log('drawDetections')
            var ctx = canvasRef.getContext("2d");
            ctx.clear();

            if (dimensions && dimensions.width > 0 && dimensions.height > 0 && detections && selectedDetection) {
                detections.forEach(function (element) {
                    if (element === selectedDetection)
                        drawRect(ctx, (element.xcenter - element.width / 2) / resizeFactor, (element.ycenter - element.height / 2) / resizeFactor, element.width / resizeFactor, element.height / resizeFactor, 'rgba(0, 0, 0, .33)', 'white', 2);
                });
                detections.forEach(function (element) {
                    if (element !== selectedDetection)
                        drawCircle(ctx, element.xcenter / resizeFactor, element.ycenter / resizeFactor, 8, 'rgba(255, 255, 255, .33)', '#FA4616', 6);
                });
            }
        })
    }, [image, detections, dimensions, canvasRef, selectedDetection, resizeFactor]);

    const upload = (<Button
        variant="outlined"
        startIcon={<CameraAlt />}
        component="label"
        sx={{
            color: '#1D252D',
            width: {xs: '60%!important', sm: '50%!important'},
            margin: 'auto',
            left: {xs: '0', sm: '0'},
            borderColor: '#1D252D',
            '&:hover': {
                borderColor: '#1D252D',
                color: '#1D252D',
            }
        }}
        >
            {isMobile ?
                <>{t('Snap a photo')}</>
                :
                <>{t('Upload image')}</>
            }
        <input
            type="file"
            hidden
            name="myImage"
            accept="image/*"
            capture="environment"
            onChange={(event) => {
                console.log("----- First image loading -----")
                checkImage(event.target.files[0]);
            }}
        />
    </Button>)

    const dropZone = (
        <Box
            sx={{
                color: '#1D252D',
                width: {xs:270, lg:350},
                margin: 'auto',
                paddingTop: '10px',
                paddingBottom: '10px',
                borderColor: '#1D252D',
                '&:hover': {
                    borderColor: '#1D252D',
                    color: '#1D252D',
                    borderStyle: 'dashed',
                    borderWidth: '3px',
                    borderRadius: '7px'
                },
                borderStyle: 'dashed',
                borderWidth: '3px',
                borderRadius: '7px'
            }}
        >
            <Stack direction='column'>
                <Typography variant="h6" sx={{textAlign:'center'}}>
                    {t('Drag & Drop image')}
                </Typography>
                <Typography variant="body2" paddingBottom='5px' sx={{textAlign:'center'}}>
                    {t('or')}
                </Typography>
                {upload}
            </Stack>
        </Box>
    )

    return (
        <Stack direction="column" spacing={2} sx={{ overflowX: 'hidden', paddingTop: {xs:'75px',sm:'35px'}, height: {xs:'calc(100vh - 20px)',sm:'auto'} }}>
            <div className={"vs-img-container"}>
                <img
                    alt={image.name}
                    ref={node => {
                        // console.log('Attached node: ', node)
                        if (node) {
                            imageRef = node;
                        }
                    }}
                    // id='vs-image'
                    className={"vs-image"}
                    src={URL.createObjectURL(image)}
                    onLoad={onImgLoad}
                    style={{
                        width: '100%',
                        maxWidth: '350px',
                        height: 'auto',
                        //maxHeight: '525px',
                        //width: '350px',
                        //height: '525px',
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                />
                <canvas
                    ref={node => {
                        // console.log('Attached node: ', node)
                        if (node) {
                            canvasRef = node;
                        }
                    }}
                    // id="vs-canvas"
                    className={"vs-canvas"}
                    width="640"
                    height="640"
                    onClick={canvasClick}
                />
            </div>
            {
                isMobile ?
                    <div className='fileuploader-container'><FileUploader handleChange={handleChange} name="file" types={fileTypes} hoverTitle={" "} children={upload} /></div>
                    :
                    <div className='fileuploader-container'><FileUploader handleChange={handleChange} name="file" types={fileTypes} hoverTitle={" "} children={dropZone} /></div>
            }
            <Divider />
            <FilterAfterFetch setFilters={setFilters} filter={filter} maxPrice={price} categories={category} api={api} />
        </Stack>
    )
}

export default ImageComponent